export default __webpack_public_path__ + "static/media/02.51d2f416.jpg";